import Paginacion from "./Paginacion";

export default Paginacion